module.exports = __webpack_public_path__ + "580d7cd48d0a2f00100852e6c07319b4.MP3";